export const app = {
  connectToYourWhatsappNumber: '连接到您的WhatsApp号码',
  connectYourWhatsappBotWithYourWhatsappNumber: '将您的WhatsApp机器人与您的WhatsApp号码连接',
  connect: '连接',
};

